const notify = (data) => {
  if (window.chrome && window.chrome.webview && window.chrome.webview.postMessage) {
    window.chrome.webview.postMessage(data);
  }
};

export const notifyError = () => {
  notify({
    method: 'notifyError'
  });
};

export const notifyLoadDone = () => {
  notify({
    method: 'notifyLoadDone',
  });
};

export const notifyOfficeLogin = (officeId, apiKey) => {
  notify({
    method: 'notifyOfficeLogin',
    officeId,
    apiKey,
  });
};

export const notifyRestart = () => {
  notify({
    method: 'restart',
  });
};